"use client";

import styles from './_modal.module.scss';

export default function HcpClinicalInformationDoseReductionsModal(index) {
  return (
    <section className={styles.container}>
      <div className={styles.content_wrapper}>
        <div className={styles.header}>
          <h2>A number of comorbidities have been linked to<br className="hidden desktop:block" /> high GC doses<sup>15,16,21</sup></h2>
        </div>

        <div className={styles.symptoms_container}>
          <div className={styles.symptoms_list}>
            <ul className={index.index===0?styles.pediatric : styles.adult}>
              <li>Obesity*</li>
              {index.index === 0 && <li>Growth issues*</li>}
              <li>Hypertension*</li>
              <li>Insulin resistance</li>
              <li>Osteopenia and osteoporosis</li>
              <li>Cognitive impairment</li>
              <li>Mood disorders</li>
            </ul>
          </div>

        </div>

        <p className={styles.disclaimer}>
          These comorbidities are listed for context and are not intended to 
          imply any clinical effect from CRENESSITY.
        </p>

        <ul className={`footnotes ${styles.footnote}`}>
          <li><span className="hang">*</span><span>These impacts could also be related to excess androgens.</span></li>
        </ul>

        <div className={styles.indication}>
          <h3>INDICATION</h3>
          <p>
            CRENESSITY (crinecerfont) is indicated as adjunctive treatment to glucocorticoid replacement <span className="mobile:text-nowrap">to control androgens</span> in adults and pediatric patients 4 years of age and older with classic congenital <span className="text-nowrap">adrenal hyperplasia</span> (CAH).
          </p>
        </div>
      </div>
    </section>
  )
}
